import { canUseDom } from "./can-use-dom";
function throwError() {
    throw new Error("can not call on server side");
}
var server = {
    track: throwError,
};
export default canUseDom ? require("intersection-observer") : server;
